import CloseIcon from '@mui/icons-material/Close';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import { Box } from '@mui/material';
import classNames from 'classnames';

import { ENOPOrganType, ICONS } from '#shared';

import { cellDrawerClasses } from './CellDrawerRoot';

export type CellDrawerHeaderProps = {
  day: 'today' | 'tomorrow';
  organ: ENOPOrganType;
  title: string;
  secondaryText: string;
  onClose: () => void;
};

export const CellDrawerHeader = ({
  day,
  organ: organIconName,
  secondaryText,
  title,
  onClose,
}: CellDrawerHeaderProps) => {
  const Icon = ICONS[organIconName];
  return (
    <Box className={cellDrawerClasses.header}>
      <Box className={cellDrawerClasses.headerPrimary}>
        <Box
          className={classNames(
            cellDrawerClasses.headerPrimaryIcon,
            organIconName,
          )}
        >
          <Icon />
        </Box>
        <Box className={cellDrawerClasses.headerPrimaryTitle}>{title}</Box>
        <Box className={cellDrawerClasses.headerPrimaryClose} onClick={onClose}>
          <CloseIcon height={22} width={22} />
        </Box>
      </Box>
      <Box className={cellDrawerClasses.headerSecondary}>
        <Box className={cellDrawerClasses.headerSecondaryLocation}>
          <Box className={cellDrawerClasses.headerSecondaryIcon}>
            <FmdGoodIcon />
          </Box>
          <Box className={cellDrawerClasses.headerSecondaryText}>
            {secondaryText}
          </Box>
        </Box>
        <Box className={cellDrawerClasses.headerSecondaryDay}>{day}</Box>
      </Box>
    </Box>
  );
};
